import { Dialog, styled } from '@mui/material';

export const StyledModal = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '600px',
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(5),
    paddingTop: `${theme.spacing(6)} !important`,
    paddingBottom: theme.spacing(3),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(5),
    paddingTop: theme.spacing(1),
  },
}));
